module.exports = __webpack_public_path__ + "b44d3a50.png";